export const LABELS_ERROR_BUTTON_DISABLE = [
  'validation.incorrectLink',
  'playlistsPage.emptyPlaylistNameError',
  'validation.notYourPlaylist',
  'validation.playlistAdded',
]
